import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { StageBackgroundProps } from '../types';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import MediaService from '../../../utils/DeviationMediaService';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';

import s from './Commission.scss';

function getCoverImageFile(
  deviation: PapiDeviation,
  showMatureContent: boolean
) {
  const { commission } = deviation;
  let coverImage: PapiDeviation | undefined = deviation.coverImage;
  if (!coverImage) {
    if (commission) {
      if (commission.examples && commission.examples.length) {
        coverImage = commission.examples[0];
      }
    }
  }
  if (coverImage && coverImage.isMature && !showMatureContent) {
    return null;
  }
  return coverImage && MediaService.getLargestFullview(coverImage);
}

export const CommissionStageBackground: React.FC<StageBackgroundProps> = ({
  deviation,
}) => {
  const showMatureContent = useContext(MatureContext);
  const isMobile = useContext(MobileContext);
  const coverImage = getCoverImageFile(deviation, showMatureContent);

  if (!coverImage) {
    return <EmptyBackground className={s['empty-background']} />;
  }

  const { src } = coverImage;

  return (
    <BackgroundImage
      src={src}
      fade={isMobile ? false : 'full-strong'}
      subtleBlur={!isMobile}
    />
  );
};
CommissionStageBackground.displayName = 'CommissionStageBackground';

export default CommissionStageBackground;
